import { getCompletionPercent, getMissingSections } from "./builder/rentalBuilderConfig";

const RentalCompletionTracker = ({
  savedStage,
  hasTerms = false,
  compact = false,
  wide = false,
}) => {
  const percent = getCompletionPercent(savedStage, hasTerms);
  const missing = getMissingSections(savedStage, hasTerms);

  if (compact) {
    return (
      <div className="flex min-w-0 items-center gap-3">
        <div className="hidden min-w-[120px] flex-col gap-1 sm:flex">
          <div className="flex items-center justify-between gap-2">
            <span className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
              Completion
            </span>
            <span className="text-sm font-bold text-gray-900">{percent}%</span>
          </div>
          <div
            className={`h-2 overflow-hidden rounded-full bg-gray-100 ${
              wide ? "w-32 lg:w-40" : "w-24"
            }`}
          >
            <div
              className="h-full rounded-full bg-primary transition-all duration-500"
              style={{ width: `${percent}%` }}
            />
          </div>
        </div>
        <div className="flex items-center gap-2 sm:hidden">
          <div className="h-2 w-20 overflow-hidden rounded-full bg-gray-100">
            <div
              className="h-full rounded-full bg-primary transition-all duration-500"
              style={{ width: `${percent}%` }}
            />
          </div>
          <span className="text-sm font-semibold text-gray-900">{percent}%</span>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-gray-200/80 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between gap-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
          Rental Completion
        </p>
        <span className="text-sm font-bold text-gray-900">{percent}%</span>
      </div>
      <div className="mt-3 h-2 overflow-hidden rounded-full bg-gray-100">
        <div
          className="h-full rounded-full bg-primary transition-all duration-500"
          style={{ width: `${percent}%` }}
        />
      </div>
      {missing.length > 0 && (
        <div className="mt-4">
          <p className="text-[11px] font-medium uppercase tracking-wide text-gray-400">
            Still needed
          </p>
          <ul className="mt-2 space-y-1">
            {missing.slice(0, 4).map((name) => (
              <li key={name} className="text-xs text-gray-600">
                · {name}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default RentalCompletionTracker;
